module.exports = __webpack_public_path__ + "static/media/entire_accomodation.2fa7f228.png";